import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../src/constants/premissions'
import { piccFleetDashboardSearchSchema } from '../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../src/utils/routePermissions'

export const Route = createFileRoute('/picc/fleet-dashboard')({
  validateSearch: (search) => piccFleetDashboardSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    permissionRequired: PERMISSION_ROLES.PICC_FLEET_DASHBOARD,
    layout: 'menu',
  },
})
